export enum SsoAccountStatus {
    /**
     * Sso authorization is enabled for all children of this parent sso account. Username/password login is prevented.
     */
    ENABLED = 'ENABLED',
    /**
     * Sso authorization is disabled for all children of this parent sso account. Username/password login is enabled.
     */
    DISABLED = 'DISABLED',
    /**
     * Sso authorization is enabled for children with the org-sso-beta-tester role. Children without the role remain as username/password.
     * <p>Allows testing the complex sso configuration settings and a partial rollout to prevent outages.
     */
    BETA = 'BETA',
}

export type SsoAccount = {
    issuer: string;
    accountId: string;
    status: SsoAccountStatus;
};

export type CommConsentRequest = {
    isEU: boolean;
    doesConsent: boolean;
};
export type AccountCreateRequest = {
    username: string;
    password: string;
    consentRequest: CommConsentRequest;
};

export type VerificationRequest = {
    code: string;
    email: string;
};

export type VerifiedPasswordResetRequest = {
    username: string;
    password: string;
    verificationRequest: VerificationRequest;
};

export type PasswordPolicy = {
    minLength: number;
    requiresLetter: boolean;
    requiresNumber: boolean;
    requiresSymbol: boolean;
    requiresUppercase: boolean;
};

export type AuthenticationRequirements = {
    isSsoRequired: boolean;
    isMfaRequired: boolean;
};

export enum SessionType {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
}

export type RedirectResponse = {
    redirectUrl: string;
};

export type LoginResponse = RedirectResponse & {
    isMfaRequired: boolean;
};

export type LoginRequest = {
    username: string;
    password: string;
    sessionType: SessionType;
    mfaCode?: string;
    next?: string;
};
